export default "__VITE_ASSET__GLSf099N__"